<template>
  <div class="sliderfilter-menu">
    <!-- <SaveFilter /> -->
    <div class="sliderfilter-card" v-for="(filterCard,index1) in selectedFilters" :key="index1">
      <div v-for="(filter,index2) in filterCard" :key="index2">
        <div class="sliderfilter-cardlist" v-if="checkPermission(filter)">
        <FilterCategory
          v-if="filter.type === 'List'"
          :category="filter.tlabel ? $t(filter.tlabel) : filter.category"
          :list="filter.list"
          :selected="filter.selected"
          :search="filter.search"
          @updateOption="updateOption(index1, index2, $event)"/>

          <template  v-if="filter.type === 'GroupList'">
            <div class="cardlist">
            <div class="cardlist-title">
              <label>{{filter.tlabel? $t(filter.tlabel) : filter.category}}</label>
            </div>
            <div class="cardlist-dropdown">
            <FilterGroupCategory
              :category="filter.tlabel? $t(filter.tlabel) : filter.category"
              :groupList="filter.list"
              :selected="filter.selected"
              :searchEnable="filter.searchEnable"
              v-on:updateOption="updateOption(index1, index2, $event)"/>
            </div>
            </div>
          </template>

        <div class="cardlist" v-else-if="filter.type === 'Date'">
          <div class="cardlist-title">
            <label>{{ filter.tlabel ? $t(filter.tlabel) : 'DATE' }}</label>
          </div>
          <div class="sliderfilter-cardlist-dropdown">
            <div class="datepickerrange calenderstyle">
              <div class="datepicker-trigger">
                <div id="datepicker-trigger">
                  {{formattedDate(filter.startDate, filter.endDate) || "Start Date - End Date"}}
                </div>
                <AirbnbStyleDatepicker
                  :trigger="openDateFilter"
                   @closed="onClosedMethod"
                  :trigger-element-id="'datepicker-trigger'"
                  :mode="'range'"
                  :date-one="filter.startDate"
                  :date-two="filter.endDate"
                  @date-one-selected="val => { updateDate(val,'startDate', index1, index2 )}"
                  @date-two-selected="val => { updateDate(val,'endDate', index1, index2 )}"/>
                </div>
                <div class="datepickerrange-cancel">
                  <svgicon v-if="formattedDate(filter.startDate,filter.endDate)" name="cancelblack"
                    class="icon-clear" @click="$emit('clearDate',index1,index2)" width="9"
                    height="9" :original="true" />
                  <svgicon v-else name="fill_arrow" width="9" height="9" :original="true" />
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div class="sliderfilter-cardbtn">
      <button class="btn section_obtn" @click="$emit('reset')">{{ $t('RESET_ALL') }}</button>
      <button class="btn section_pbtn" @click="search">{{ $t('APPLY') }}</button>
    </div>
  </div>
</template>
<script>
import FilterCategory from '@common/components/FilterCategory';
import FilterGroupCategory from '@common/components/FilterGroupCategory';
import { filters } from '@/constants/payments';
import { formatDisplayDate } from '@/lib/Date';

export default {
  props: ['selectedFilters'],
  components: {
    FilterCategory,
    FilterGroupCategory,
  },
  data() {
    return {
      openDateFilter: false,
      filters,
    };
  },
  computed: {
    keys() {
      return Object.keys(this.selectedFilters);
    },
  },
  methods: {
    onClosedMethod() {
      this.openDateFilter = false;
    },
    checkPermission(filter) {
      // eslint-disable-next-line no-prototype-builtins
      return filter.hasOwnProperty('hasPermission') ? filter.hasPermission : true;
    },
    formattedDate(startDate, endDate) {
      return formatDisplayDate(startDate, endDate);
    },
    updateOption(index1, index2, data) {
      if (data.invokeDateFilterEvent) {
        this.openDateFilter = true;
      }
      this.$emit('updateOption', index1, index2, data);
    },
    updateDate(val, type, index1, index2) {
      this.$emit('updateOption', index1, index2, val, type);
    },
    search() {
      const params = {};
      this.keys.forEach((value) => {
        params[value] = this[value];
      });
      this.$emit('search', params);
    },
    clearDate() {
      this.startDate = '';
      this.endDate = '';
    },
  },
};
</script>
